function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Not authorized(80px)");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "47.7012819%",
  y1: "48.9352536%",
  x2: "75.2121386%",
  y2: "76.5220567%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.07,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.28,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.0853124521%",
  y1: "52.0534905%",
  x2: "99.908413%",
  y2: "52.0534905%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCDC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1C1C1",
  offset: "7%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B5B5B5",
  offset: "16.8269231%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D5D5D5",
  offset: "27.2590691%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D9D9D",
  offset: "43%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1A1A1",
  offset: "93%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D7D7",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "47.7638854%",
  y1: "48.9634361%",
  x2: "74.6619232%",
  y2: "75.9171412%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#949494",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "47.2902677%",
  cy: "50%",
  fx: "47.2902677%",
  fy: "50%",
  r: "41.4607152%",
  gradientTransform: "translate(0.472903,0.500000),scale(0.578986,1.000000),rotate(94.586123),scale(1.000000,1.891098),translate(-0.472903,-0.500000)",
  id: "radialGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.27,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "41.5214086%",
  y1: "43.6801415%",
  x2: "78.0672269%",
  y2: "81.7532649%",
  id: "linearGradient-5"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.12,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.1,
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "62.3223427%",
  cy: "74.9132311%",
  fx: "62.3223427%",
  fy: "74.9132311%",
  r: "110.291949%",
  gradientTransform: "translate(0.623223,0.749132),scale(1.000000,0.654580),rotate(-90.000000),scale(1.000000,0.534508),translate(-0.623223,-0.749132)",
  id: "radialGradient-6"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#949494",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3E3E3",
  offset: "85%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAFAFA",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "56.2287221%",
  cy: "28.8688094%",
  fx: "56.2287221%",
  fy: "28.8688094%",
  r: "131.419159%",
  gradientTransform: "translate(0.562287,0.288688),scale(1.000000,0.627349),rotate(-97.538148),scale(1.000000,1.741939),translate(-0.562287,-0.288688)",
  id: "radialGradient-7"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAFAFA",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3E3E3",
  offset: "38.0953056%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#949494",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "523.604627%",
  cy: "-82.7363154%",
  fx: "523.604627%",
  fy: "-82.7363154%",
  r: "561.610519%",
  gradientTransform: "translate(5.236046,-0.827363),scale(1.000000,0.248445),rotate(-95.547759),translate(-5.236046,0.827363)",
  id: "radialGradient-8"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#818181",
  offset: "47%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E4E4",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "-24.274538%",
  cy: "-185.697909%",
  fx: "-24.274538%",
  fy: "-185.697909%",
  r: "137.672704%",
  gradientTransform: "translate(-0.242745,-1.856979),scale(1.000000,0.556756),rotate(-78.203857),translate(0.242745,1.856979)",
  id: "radialGradient-9"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#474747",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#191919",
  offset: "82%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Not-authorized(80px)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(17.000000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard-3-copy-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_0_FILL",
  transform: "translate(0.000000, 26.440678)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.6594118,2.17627119 L43.5647059,2.23050847 L17.9738235,17.0711864 C15.779628,18.468572 12.9771367,18.468572 10.7829412,17.0711864 L2.23911765,12.1355932 C1.17029412,11.5118644 0.575,10.8881356 0.46,10.2644068 L0.46,35.3966102 C0.443255905,35.5135252 0.443255905,35.6322375 0.46,35.7491525 C0.46,35.7491525 0.46,35.8033898 0.46,35.8237288 C0.522259655,36.1378861 0.669719003,36.4287652 0.886176471,36.6644068 C1.06658408,36.8616643 1.26347642,37.043115 1.47470588,37.2067797 C1.72071824,37.3870941 1.97586227,37.5545489 2.23911765,37.7084746 L10.7829412,42.6440678 C12.9771367,44.0414534 15.779628,44.0414534 17.9738235,42.6440678 L43.5647059,27.7966102 C44.7214706,27.1186441 45.3167647,26.440678 45.3573529,25.7627119 L45.3573529,25.7627119 L45.3573529,0.203389831 L45.3573529,0.203389831 C45.3504062,0.283476226 45.3368301,0.362845452 45.3167647,0.440677966 C45.1882353,1.01694915 44.6470588,1.6 43.6594118,2.17627119 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_1_FILL",
  transform: "translate(0.000000, 52.881356)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.1938235,6.90847458 C44.0504078,6.80736674 43.901341,6.71455992 43.7473529,6.63050847 L35.1764706,1.68813559 C32.9796131,0.308445823 30.1892104,0.308445823 27.9923529,1.68813559 L2.42852941,16.5152542 C1.35294118,17.1457627 0.764411765,17.7627119 0.649411765,18.3864407 C0.629152278,18.5280896 0.629152278,18.6719104 0.649411765,18.8135593 L0.649411765,18.8135593 C0.764411765,19.4372881 1.32588235,20.0610169 2.42852941,20.6847458 L10.9723529,25.620339 C13.1665485,27.0177246 15.9690397,27.0177246 18.1632353,25.620339 L43.7541176,10.7932203 L43.8488235,10.7389831 C44.8229412,10.1627119 45.3776471,9.57966102 45.5061765,9.00338983 C45.5262418,8.92555732 45.539818,8.84618809 45.5467647,8.76610169 C45.5738235,8.13559322 45.1205882,7.53220339 44.1938235,6.90847458 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_2_FILL",
  transform: "translate(0.000000, 26.440678)",
  fill: "url(#linearGradient-2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.8488235,2.37288136 L43.7541176,2.42033898 L18.1632353,17.2677966 C15.9647497,18.6503205 13.1708385,18.6503205 10.9723529,17.2677966 L2.42852941,12.3254237 C1.35294118,11.7016949 0.764411765,11.0779661 0.676470588,10.4542373 L0.676470588,35.5932203 C0.662972422,35.7080776 0.662972422,35.8241258 0.676470588,35.9389831 C0.679101459,35.9637719 0.679101459,35.9887705 0.676470588,36.0135593 C0.741928814,36.3265981 0.888977003,36.6166661 1.10264706,36.8542373 C1.28376769,37.0532379 1.48306745,37.23482 1.69794118,37.3966102 C1.93886138,37.580846 2.19199334,37.7484636 2.45558824,37.8983051 L10.9994118,42.840678 C13.1978973,44.2232019 15.9918085,44.2232019 18.1902941,42.840678 L43.7811765,27.9932203 C44.9447059,27.3152542 45.54,26.6372881 45.5738235,25.959322 L45.5738235,25.959322 L45.5738235,0.4 L45.5738235,0.4 C45.5663125,0.477779358 45.5527417,0.55485064 45.5332353,0.630508475 C45.3776471,1.21355932 44.8229412,1.78983051 43.8488235,2.37288136 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_3_FILL",
  transform: "translate(0.000000, 18.305085)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.0044118,6.87457627 C43.8691176,6.77966102 43.7135294,6.69152542 43.5511765,6.59661017 L35.0073529,1.65423729 C32.8149488,0.267556588 30.0224041,0.267556588 27.83,1.65423729 L2.23911765,16.4813559 C1.16352941,17.1118644 0.575,17.7355932 0.46,18.3525424 C0.4329618,18.4936259 0.4329618,18.6385775 0.46,18.779661 L0.46,18.779661 C0.575,19.4033898 1.13647059,20.0271186 2.23911765,20.6508475 L10.7829412,25.5864407 C12.9771367,26.9838262 15.779628,26.9838262 17.9738235,25.5864407 L43.5647059,10.759322 L43.6594118,10.7050847 C44.6470588,10.1288136 45.1882353,9.54576271 45.3235294,8.96949153 C45.3435948,8.89165901 45.3571709,8.81228979 45.3641176,8.73220339 C45.3844118,8.13559322 44.9311765,7.49830508 44.0044118,6.87457627 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_4_FILL",
  transform: "translate(0.000000, 18.305085)",
  fill: "url(#linearGradient-3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.1938235,6.6779661 C44.0585294,6.58305085 43.9097059,6.48813559 43.7473529,6.39322034 L35.1764706,1.45084746 C32.9796131,0.0711576878 30.1892104,0.0711576878 27.9923529,1.45084746 L2.42852941,16.2711864 C1.35294118,16.8949153 0.764411765,17.5186441 0.649411765,18.1423729 C0.629148118,18.28175 0.629148118,18.4233348 0.649411765,18.5627119 L0.649411765,18.5627119 C0.764411765,19.1864407 1.32588235,19.8101695 2.42852941,20.4338983 L10.9723529,25.3762712 C13.1708385,26.7587951 15.9647497,26.7587951 18.1632353,25.3762712 L43.7541176,10.5288136 L43.8488235,10.4813559 C44.8229412,9.89830508 45.3776471,9.3220339 45.5061765,8.73898305 C45.5256829,8.66332522 45.5392537,8.58625393 45.5467647,8.50847458 C45.5738235,7.91186441 45.1205882,7.29491525 44.1938235,6.6779661 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_6_FILL",
  transform: "translate(8.794118, 0.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.3529412,3.38983051 C24.4628773,3.45120618 24.5690477,3.51912434 24.6708824,3.59322034 C23.4204866,2.59334036 22.0584143,1.74243831 20.6120588,1.05762712 C18.4518627,-0.0542372881 15.7527451,0.327683616 12.5147059,2.20338983 L12.1358824,2.42033898 C8.89333333,4.2960452 6.12656863,7.23389831 3.83558824,11.2338983 C1.90123547,14.4079848 0.729428315,17.9892016 0.412647059,21.6949153 C0.412647059,22.0745763 0.412647059,22.4542373 0.412647059,22.8338983 L0.412647059,36.7864407 L0.412647059,36.7864407 C0.423142227,37.0456617 0.500019028,37.2978147 0.635882353,37.5186441 C0.655534813,37.5408122 0.671521223,37.5659893 0.683235294,37.5932203 C0.924286223,37.914382 1.23103868,38.1802054 1.58294118,38.3728814 C2.29573566,38.7765205 3.09237737,39.0086144 3.91,39.0508475 L3.91,24.8745763 C3.90280663,23.8097462 3.9842656,22.7461707 4.15352941,21.6949153 C4.70252519,18.7021496 5.78160012,15.8320314 7.33970588,13.220339 C9.63519608,9.23389831 12.4042157,6.2960452 15.6467647,4.40677966 L16.0188235,4.18983051 C19.2658824,2.30056497 22.0439216,2.03389831 24.3529412,3.38983051 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_7_FILL",
  transform: "translate(6.088235, 21.694915)",
  fill: "url(#radialGradient-4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9411765,4.65620732 C18.9411765,5.93982314 19.7303922,7.03586834 21.3088235,7.94434291 C23.0438532,8.89518083 25.0011665,9.36335278 26.9776471,9.30027512 C28.9606563,9.36402756 30.9246819,8.89592588 32.6667647,7.94434291 C34.2361765,7.04038811 35.0186275,5.94434291 35.014137,4.65620732 C35.014137,3.36807173 34.2429412,2.2765463 32.6735294,1.36129206 C30.9306224,0.411864606 28.9671888,-0.0560959807 26.9844118,0.00535986118 C25.0082659,-0.0544289458 23.0518013,0.413540006 21.3155882,1.36129206 C19.7394118,2.26976664 18.9547059,3.36807173 18.9411765,4.65620732 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-2.9320337e-13,15.5036649 C-2.9320337e-13,16.7872808 0.789215686,17.883326 2.36764706,18.7918005 C4.10267674,19.7426385 6.05999007,20.2108104 8.03647059,20.1477327 C10.0194798,20.2114852 11.9835054,19.7433835 13.7255882,18.7918005 C15.295,17.8878457 16.077451,16.7918005 16.0729606,15.5036649 C16.0729606,14.2155294 15.3017647,13.1240039 13.7323529,12.2087497 C11.9894459,11.2593222 10.0260123,10.7913616 8.04323529,10.8528175 C6.06708946,10.7930287 4.11062482,11.2609976 2.37441176,12.2087497 C0.798235294,13.1172243 0.0135294118,14.2155294 -2.9320337e-13,15.5036649 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_8_FILL",
  transform: "translate(10.147059, 22.372881)",
  fill: "url(#linearGradient-5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.88882353,20.820339 L14.3885294,17.6271186 L5.66205882,12.379661 L0.297647059,16.0271186 L8.88882353,20.8135593 M24.2176471,0.474576271 L21.1938235,4.62372881 L29.0882353,9.11864407 L33.6273529,6.48813559 L33.7220588,6.44067797 L34.1076471,6.19661017 L24.2176471,0.474576271 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_9_FILL",
  transform: "translate(12.852941, 2.033898)",
  fill: "url(#radialGradient-6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.7744118,1.56610169 C20.6725771,1.4920057 20.5664067,1.42408754 20.4564706,1.36271186 C18.1654902,0.00677966102 15.3964706,0.280225989 12.1494118,2.18305085 L11.7773529,2.4 C8.53480392,4.27118644 5.76578431,7.20903955 3.47029412,11.2135593 C1.91518626,13.8169553 0.836208067,16.6776325 0.284117647,19.6610169 C0.106829367,20.6981807 0.0118261352,21.7477935 0,22.8 L0,36.9762712 C0.162352941,36.9762712 0.324705882,36.9762712 0.487058824,36.9762712 C0.703529412,36.9762712 0.906470588,36.9762712 1.10264706,36.9762712 C1.88042106,36.9141957 2.63532234,36.6828287 3.31470588,36.2983051 C3.66369626,36.1068694 3.96627233,35.840662 4.20088235,35.5186441 C4.30597717,35.3660331 4.38380228,35.1962745 4.43088235,35.0169492 C4.45755416,34.9126483 4.47342241,34.8058688 4.47823529,34.6983051 L4.47823529,22.8067797 C4.48218212,21.7323633 4.61620082,20.6623965 4.87735294,19.620339 C5.29877463,18.0083998 5.94315819,16.4634807 6.79176471,15.0305085 C8.08371695,12.6040188 10.0016841,10.5694291 12.3455882,9.13898305 L12.5958824,8.98983051 C13.6534651,8.31766172 14.8690416,7.93651583 16.1202941,7.88474576 C16.8333296,7.89121249 17.532525,8.08274843 18.1497059,8.44067797 C19.3772133,9.20356901 20.1781141,10.4978767 20.3144118,11.9389831 C20.4108818,12.4738564 20.4629229,13.015827 20.47,13.559322 L20.47,14.1084746 L20.47,25.2949153 C20.7645215,25.2972425 21.0587104,25.2745626 21.3494118,25.2271186 C21.7468164,25.1729814 22.1342234,25.0610702 22.4994118,24.8949153 L22.8647059,24.7118644 C23.2501933,24.5210147 23.5652394,24.2123942 23.7644118,23.8305085 C23.8163751,23.7190177 23.8506127,23.600065 23.8658971,23.4779661 L23.8658971,8.96949153 C23.8703922,5.4079096 22.839902,2.94011299 20.7744118,1.56610169 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_10_FILL",
  transform: "translate(8.794118, 0.000000)",
  fill: "url(#radialGradient-7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5152941,3.38983051 C24.6252302,3.45120618 24.7314006,3.51912434 24.8332353,3.59322034 C23.5828395,2.59334036 22.2207672,1.74243831 20.7744118,1.05762712 C18.6502941,-0.0542372881 15.9601961,0.327683616 12.7041176,2.20338983 L12.3252941,2.42033898 C9.06921569,4.30056497 6.31372549,7.23163842 4.05882353,11.2135593 C2.11152534,14.3910813 0.930257187,17.9798616 0.608823529,21.6949153 C0.608823529,22.0745763 0.608823529,22.4542373 0.608823529,22.8338983 L0.608823529,36.7864407 L0.608823529,36.7864407 C0.621960059,37.0461672 0.701133557,37.2982155 0.838823529,37.5186441 L0.879411765,37.5932203 C1.12210023,37.9128445 1.42849665,38.1783594 1.77911765,38.3728814 C2.49191213,38.7765205 3.28855384,39.0086144 4.10617647,39.0508475 L4.10617647,24.8745763 C4.10019098,23.8100513 4.17936615,22.7467585 4.34294118,21.6949153 C4.89193695,18.7021496 5.97101189,15.8320314 7.52911765,13.220339 C9.82460784,9.23389831 12.5936275,6.2960452 15.8361765,4.40677966 L16.2082353,4.18983051 C19.4552941,2.30056497 22.2243137,2.03389831 24.5152941,3.38983051 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_11_FILL",
  transform: "translate(28.411765, 9.491525)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.73529412,6.66440678 L4.73529412,6.10169492 C4.73852672,5.56366885 4.69780245,5.02628063 4.61352941,4.49491525 C4.47723179,3.05380888 3.67633097,1.75950122 2.44882353,0.996610169 C1.83164268,0.63868063 1.1324472,0.447144695 0.419411765,0.440677966 C1.01064336,1.56450311 1.29313425,2.82565355 1.23794118,4.09491525 L1.23794118,4.6440678 L1.23794118,16 C1.25104881,16.0807753 1.27142609,16.1601955 1.29882353,16.2372881 C1.4764502,16.6798054 1.81488262,17.0383678 2.24588235,17.240678 C2.99339894,17.6575859 3.83964461,17.8637579 4.69470588,17.8372881 L4.74882353,17.8372881 L4.73529412,6.66440678 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_12_FILL",
  transform: "translate(28.411765, 9.491525)",
  fill: "url(#radialGradient-8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.91119771,6.66440678 L4.91119771,6.10169492 C4.91229391,5.56347851 4.8693063,5.02607915 4.78264706,4.49491525 C4.64634943,3.05380888 3.84544861,1.75950122 2.61794118,0.996610169 C2.00076033,0.63868063 1.30156485,0.447144695 0.588529412,0.440677966 C1.18286485,1.56335467 1.46554771,2.82536216 1.40705882,4.09491525 L1.40705882,4.6440678 L1.40705882,16 C1.41463395,16.0811328 1.43282937,16.1609137 1.46117647,16.2372881 C1.64107487,16.6783414 1.97882017,17.0361758 2.40823529,17.240678 C3.15575188,17.6575859 4.00199755,17.8637579 4.85705882,17.8372881 L4.91119771,17.8372881 L4.91119771,6.66440678 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_13_FILL",
  transform: "translate(29.088235, 46.101695)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.94264706,0.766101695 C1.35050391,1.79036485 0.344401228,3.51712472 0.236764706,5.41016949 C0.152138436,6.08893269 0.452190138,6.75835053 1.01470588,7.14576271 C1.26535869,7.2880947 1.55282872,7.35185576 1.84,7.32881356 L1.84,9.36271186 C1.80789048,9.6278335 1.92512655,9.88893406 2.14441176,10.040678 C2.38657747,10.1710242 2.68336531,10.1415478 2.89529412,9.96610169 C3.21313964,9.77534166 3.47281781,9.50102172 3.64617647,9.17288136 C3.85109815,8.86445329 3.96805326,8.50577947 3.98441176,8.13559322 L3.98441176,6.10169492 C4.30164718,5.75052883 4.58057981,5.36643266 4.81647059,4.9559322 C5.30364567,4.16073024 5.57421465,3.25138526 5.60117647,2.31864407 C5.68374911,1.63829649 5.38443382,0.967913103 4.82323529,0.576271186 C4.20989789,0.284289308 3.48556816,0.357404665 2.94264706,0.766101695 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer0_2_MEMBER_14_FILL",
  transform: "translate(29.088235, 46.101695)",
  fill: "url(#radialGradient-9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.74647059,0.562711864 C1.15677969,1.58932921 0.151475659,3.31471838 0.0405882353,5.20677966 C-0.0456252242,5.88578064 0.254782131,6.55599194 0.818529412,6.94237288 C1.06706096,7.0901593 1.35627897,7.15430806 1.64382353,7.12542373 L1.64382353,9.15932203 C1.62192481,9.41998139 1.75160466,9.67001389 1.97705498,9.80181732 C2.2025053,9.93362075 2.48350212,9.92367926 2.69911765,9.77627119 C3.32388709,9.3642041 3.71764954,8.68050877 3.76117647,7.93220339 L3.76117647,5.89830508 C4.09170143,5.54761622 4.38212766,5.16104114 4.62705882,4.74576271 C5.11426688,3.95306209 5.38488691,3.04588362 5.41176471,2.11525424 C5.54638779,1.43117105 5.23301967,0.736845973 4.63151562,0.386467932 C4.03001157,0.0360898925 3.27292896,0.106873992 2.74647059,0.562711864 L2.74647059,0.562711864 Z",
  id: "Path"
})))));

var SvgNotAuthorized = function SvgNotAuthorized(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotAuthorized, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Not-authorized.464d1995.svg";
export { ForwardRef as ReactComponent };